import { useAuth0 } from "@auth0/auth0-react";
import { useCallback } from "react";
import { useCachePersistorContext } from "~@/context/cache-persistor-context";

const useExitApp = () => {
  const { logout } = useAuth0();

  const [, , clearCache] = useCachePersistorContext();

  const exitApp = useCallback(() => {
    clearCache();
    logout();
  }, [clearCache, logout]);

  return exitApp;
};

export default useExitApp;
